import { render } from "./PembenihanIkan.vue?vue&type=template&id=2cbdae32"
import script from "./PembenihanIkan.vue?vue&type=script&lang=js"
export * from "./PembenihanIkan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__